import { ContextService } from '../../../services/context_service';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { StandorteGebaeudeBestand } from './StandorteGebaeudeBestand';
import { StandorteGebaeudeSanierung } from './StandorteGebaeudeSanierung';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import '../../../css/tabs.css';

interface StandorteGebaeudeProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
    standortSelected: any;
}

interface StandorteGebaeudeState {
    tabIndex: number;
}

export class StandorteGebaeude extends React.Component<StandorteGebaeudeProps, StandorteGebaeudeState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: this.contextService.get('tabIdxStandorteDetailGebaeude')
                ? this.contextService.get('tabIdxStandorteDetailGebaeude')
                : 0
        };
    }
    @lazyInject(ContextService) private contextService: ContextService;

    componentDidMount() {
        const { routing } = this.props;
        const tabName = 'tabStandorteDetailGebaeude';

        if (routing && routing.path && routing.path[tabName]) {
            this.setState({ tabIndex: routing.path[tabName] });
            if (routing.path.terminateOn && routing.path.terminateOn === tabName) {
                this.props.onRoutingChange({ });
            }
        }
    }

    getTabStyle(idx: number): any {
        const tabColor = '#ddd';
        const tabColorBorder = '#ddd';
        const tabColorSelected = '#fff';

        return {
            backgroundColor: this.state.tabIndex === idx ? tabColorSelected : tabColor,
            borderColor: tabColorBorder,
            borderRadius: 0
        };
    }

    render(): JSX.Element {
        return (
            <div
                style={{ minWidth: '800px' }}
            >
                <Tabs
                    selectedIndex={this.state.tabIndex}
                    onSelect={
                        (tabIndex, lastIndex, event) => this.setState(
                            {tabIndex},
                            () => {
                                console.log(event);
                                this.contextService.set('tabIdxStandorteDetailGebaeude', this.state.tabIndex);
                            }
                        )
                    }
                >
                    <TabList>
                        <Tab style={this.getTabStyle(0)}>Gebäudebestand</Tab>
                        <Tab style={this.getTabStyle(1)}>Sanierungen</Tab>
                    </TabList>
                    <TabPanel>
                        <StandorteGebaeudeBestand
                            standortSelected={this.props.standortSelected}
                        />
                    </TabPanel>
                     <TabPanel>
                        <StandorteGebaeudeSanierung
                            standortSelected={this.props.standortSelected}
                            data={this.props.data}
                       />
                    </TabPanel>
                 </Tabs>
            </div>
        );
    }
}
